module.exports = __webpack_public_path__ + "static/media/ball2.0266ce5c.jpg";